/**
 * PageHelmet component that queries for data with
 *  Gatsby's useStaticQuery React hook
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React from 'react'
import PropTypes from 'prop-types'
import Helmet from 'react-helmet'
import { useStaticQuery, graphql } from 'gatsby'

const PageHelmet = ({ description, lang, meta, canonical, location, title, titleTemplate, backgroundColor }) => {
  const { site } = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            title
            description
            siteUrl
          }
        }
      }
    `
  )

  const metaDescription = description || site.siteMetadata.description
  const locationHref = location && Object.keys(location).length > 0 ? location.href : undefined
  const canonicalValue = canonical === false ? undefined : canonical || locationHref

  return (
    <Helmet
      htmlAttributes={{
        lang
      }}
      title={title}
      titleTemplate={`%s | ${titleTemplate || site.siteMetadata.title}`}
      meta={[
        {
          name: `description`,
          content: metaDescription,
        },
        {
          property: `og:title`,
          content: title,
        },
        {
          property: `og:description`,
          content: metaDescription,
        },
        {
          property: `og:type`,
          content: `website`,
        },
        {
          name: `twitter:card`,
          content: `summary`,
        },
        {
          name: `twitter:creator`,
          content: site.siteMetadata.author,
        },
        {
          name: `twitter:title`,
          content: title,
        },
        {
          name: `twitter:description`,
          content: metaDescription,
        },
      ].concat(meta)}
    >
      {
        canonicalValue && <link rel="canonical" href={canonicalValue} />
      }
      <style type="text/css">
      {`
        body { 
          background-color: ${backgroundColor};
        }

        @media print {
          body {
            height: auto;
          }
        }
      `}
      </style>
    </Helmet>
  )
}

PageHelmet.defaultProps = {
  lang: `en`,
  meta: [],
  description: ``,
}

PageHelmet.propTypes = {
  description: PropTypes.string,
  lang: PropTypes.string,
  meta: PropTypes.arrayOf(PropTypes.object),
  title: PropTypes.string.isRequired,
}

export default PageHelmet
